import React, { FormEvent, useEffect } from 'react';
import useTranslate from '../../i18n/useTranslate';
import DotFalling from '../reusable/spinner/DotFalling';
import Input from './InputComponents/Input';
import {
  AuthContainer,
  AuthForm,
  AuthHeader,
  AuthHeaderTitle,
  AuthHeaderSubtitle,
  AuthInputsGrid,
  AuthButtonGroup,
  AuthPrimaryButton,
  AuthPreviousStepButton,
} from './StyledComponents/AuthStyled';
import { extractValues } from '@src/common';
import { useAppDispatch, useAppSelector } from '../../core/hooks';
import { resetPassword, sendingFormSelector, setErrors } from '../../features/auth';
import { PASSWORD_RESET } from './ForgotPassword';
import { track } from '@src/services/analytics';

interface PasswordResetProps {
  onBack: () => void;
}
const PasswordReset = ({ onBack }: PasswordResetProps) => {
  const dispatch = useAppDispatch();
  const { i18n } = useTranslate();
  const loading = useAppSelector(sendingFormSelector);

  useEffect(() => {
    dispatch(setErrors(PASSWORD_RESET, {}));

    track('recoveryPasswordEmailStepAccess');
  }, []);

  const handleSubmit = (ev: FormEvent<HTMLFormElement>) => {
    ev.preventDefault();

    const values = extractValues(ev.target as HTMLFormElement);

    track('recoveryPasswordEmailStepSubmit');

    dispatch(
      resetPassword({
        email: values.email,
      }),
    );
  };

  return (
    <AuthContainer>
      <AuthForm key={PASSWORD_RESET} onSubmit={handleSubmit}>
        <AuthHeader>
          <AuthHeaderTitle>{i18n('auth_recoverPassword')}</AuthHeaderTitle>
          <AuthHeaderSubtitle>{i18n('auth_passwordResetSubtitle')}</AuthHeaderSubtitle>
        </AuthHeader>
        <AuthInputsGrid>
          <Input required={true} type='email' name='email' label='E-mail' errorContext={PASSWORD_RESET} />
        </AuthInputsGrid>
        <AuthButtonGroup>
          <AuthPrimaryButton>{loading ? <DotFalling /> : i18n('auth_submit')}</AuthPrimaryButton>
          <AuthPreviousStepButton onClick={() => onBack()}>{i18n('auth_goBackButton')}</AuthPreviousStepButton>
        </AuthButtonGroup>
      </AuthForm>
    </AuthContainer>
  );
};

export default PasswordReset;
